import { normalizeTextNodes } from '../domop';

export function removeHighlightElements(baseNode: Element, selector: string) {
    const nodes = Array.from(baseNode.querySelectorAll(selector));
    for (let i = 0, ii = nodes.length; i < ii; i++) {
        const fragment = document.createDocumentFragment();
        const node = nodes[i];
        const container = node.parentNode;
        while (node.firstChild) {
            fragment.appendChild(node.firstChild);
        }
        container.replaceChild(fragment, node);
        normalizeTextNodes(container);
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/removeHighlightElements.tsx